import RecepcaoContratosTypes from './types'

export const clear = () => ({
    type: RecepcaoContratosTypes.CLEAR
});

export const searchSuccess = (data) => ({
    type: RecepcaoContratosTypes.SEARCH_SUCCESS,
    payload: data
})

export const searchRequest = (protocolo, fields = []) => ({
    type: RecepcaoContratosTypes.SEARCH_REQUEST,
    protocolo: protocolo,
    fields: fields
});

export const recepcionarSuccess = (data) => ({
    type: RecepcaoContratosTypes.RECEPCIONAR_SUCCESS,
    payload: data
})

export const recepcionarRequest = (data) => ({
    type: RecepcaoContratosTypes.RECEPCIONAR_REQUEST,
    payload: data
});

export const requestFailure = ( payload ) => ({
    type: RecepcaoContratosTypes.REQUEST_FAILURE,
    payload
})

export const searchUsuarioRequest = () => ({
    type: RecepcaoContratosTypes.SEARCH_USUARIOS_REQUEST
})

export const searchUsuarioSuccess = (data) => ({
    type: RecepcaoContratosTypes.SEARCH_USUARIOS_SUCCESS,
    payload: data
})
